import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { EMISORDOCUMENTOS_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function EmisorDocumentosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${EMISORDOCUMENTOS_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
